import Modal from "react-bootstrap/Modal";
import "./filter_modal_bs.css";

function FilterModal_BS({ clientsData, show, onHide, setFilter }) {
  // const logoNames = {
  //   "aditya-birla": "Aditya Birla.png",
  //   "amazon-mini": "Amazon Mini TV.png",
  //   axe: "Axe.png",
  //   "bharat-pe": "Bharat Pe Logo-11.png",
  //   cashe: "Cashe Logo-15.png",
  //   chaayos: "Grofers Logo-03.png",
  //   crickpe: "Crickpe.png",
  //   "first-cry": "Firstcry Logo-06.png",
  //   flipkart: "Flipkart Logo-09.png",
  //   grofers: "Grofers Logo-02.png",
  //   indofarm: "IndoFarm Logo-07.png",
  //   khatabook: "Khatabook Logo-04.png",
  //   "khel-play": "Khelplay Logo-08.png",
  //   "mpl-rummy": "MPL Rummy Logo-12.png",
  //   reliance: "Reliance Logo-01.png",
  //   slice: "Slice Logo-13.png",
  //   slurrp: "Slurrp Farm Logo-14.png",
  //   unimoni: "Unimoni Logo-05.png",
  //   "wai-wai-city": "Wai Wai City Logo-10.png",
  // };

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      centered
    >
      {/* <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header> */}
      <Modal.Body>
        {/* <h4>Centered Modal</h4>
        <p>
          Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
          dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
          consectetur ac, vestibulum at eros.
        </p> */}

        <div className="m-md-5">
          <div style={{ maxHeight: "75vh", overflowY: "auto" }}>
            <div
              className="align-items-center d-flex flex-row flex-wrap justify-content-center"
              style={{
                rowGap: "0.25rem",
                columnGap: "0.25rem",
                paddingLeft: "0.25rem",
                overflow: "hidden",
              }}
            >
              {
              // Object.keys(logoNames).map((logoId, index) => (
                clientsData.map((clientData, index) => (
                <button
                  // key={logoId}
                  key={clientData.id}
                  className="ratio ratio-1x1 logo-button"
                  style={{
                    // backgroundImage: `url("images/work-logos/${logoNames[logoId]}")`,
                    backgroundImage: `url("${clientData.logoImage}")`,
                    backgroundPosition: "center center",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundColor: "transparent",
                    border: "none",
                    width:
                      window.innerWidth < window.innerHeight
                        ? "calc(33% - 0.25rem)"
                        : "calc(20% - 0.25rem)",
                  }}
                  onClick={() => {
                    setFilter(clientData.id);
                    onHide();
                  }}
                ></button>
              ))}
            </div>
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default FilterModal_BS;
